import { jsx as _jsx } from "react/jsx-runtime";
import { token } from "@filadd/phi-plus-styled-system/tokens";
import { ChatTeardropText, ChatText, Compass, HandCoins, PaperPlaneTilt, Pen, Trophy, } from "@phosphor-icons/react";
import { NotificationSources } from "../../types";
export const NotificationIcon = ({ source, seen }) => {
    const iconProps = {
        width: token("sizes.6"),
        height: token("sizes.6"),
        weight: "duotone",
        color: seen ? token("colors.neutral.500") : token("colors.primary"),
    };
    switch (source) {
        case NotificationSources.QUERIES:
            return _jsx(ChatText, Object.assign({}, iconProps));
        case NotificationSources.ORIENTATION:
            return _jsx(Compass, Object.assign({}, iconProps));
        case NotificationSources.GAMIFICATION:
            return _jsx(Trophy, Object.assign({}, iconProps));
        case NotificationSources.CHECKOUT:
            return _jsx(HandCoins, Object.assign({}, iconProps));
        case NotificationSources.CONSULTATION:
            return _jsx(ChatTeardropText, Object.assign({}, iconProps));
        case NotificationSources.ESSAY:
            return _jsx(Pen, Object.assign({}, iconProps));
        default: {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const _exhaustiveCheck = source;
            // Fallback to a generic icon
            return _jsx(PaperPlaneTilt, Object.assign({}, iconProps));
        }
    }
};
//# sourceMappingURL=NotificationIcon.js.map